module.exports = __webpack_public_path__ + "img/mastercard.4d884409.svg";